import logo from "./logo.svg";
import "./App.css";
import MyButton from "./components/MyButton";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./components/Home";

import CiudadDeMexico from "./components/Ciudad de México";
import QuintanaRoo from "./components/QuintanaRoo";
import Yucatan from "./components/Yucatan";
import Aguascalientes from "./components/Aguascalientes";
import BajaCaliforniaSur from "./components/Baja California Sur";
import BajaCalifornia from "./components/Baja California";
import Campeche from "./components/Campeche";
import Chiapas from "./components/Chiapas";
import Chihuahua from "./components/Chihuahua";
import Colima from "./components/Colima";
import Coahuila from "./components/Coahuila";
import Durango from "./components/Durango";
import EstadoDeMexico from "./components/Estado de México";
import Guanajuato from "./components/Guanajuato";
import Guerrero from "./components/Guerrero";
import Hidalgo from "./components/Hidalgo";
import Jalisco from "./components/Jalisco";
import Michoacan from "./components/Michoacan";
import Morelos from "./components/Morelos";
import Nayarit from "./components/Nayarit";
import NuevoLeon from "./components/Nuevo León";
import Oaxaca from "./components/Oaxaca";
import Puebla from "./components/Puebla";
import Queretaro from "./components/Querétaro";
import SanLuisPotosi from "./components/San Luis Potosí";
import Sinaloa from "./components/Sinaloa";
import Sonora from "./components/Sonora";
import Tabasco from "./components/Tabasco";
import Tamaulipas from "./components/Tamaulipas";
import Tlaxcala from "./components/Tlaxcala";
import Veracruz from "./components/Veracruz";
import Zacatecas from "./components/Zacatecas";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Aguascalientes" element={<Aguascalientes />} />
          <Route path="/Baja California Sur" element={<BajaCaliforniaSur />} />
          <Route path="/Baja California" element={<BajaCalifornia />} />
          <Route path="/Campeche" element={<Campeche />} />
          <Route path="/Chiapas" element={<Chiapas />} />
          <Route path="/Chihuahua" element={<Chihuahua />} />
          <Route path="/Coahuila" element={<Coahuila />} />
          <Route path="/Colima" element={<Colima />} />
          <Route path="/Durango" element={<Durango />} />
          <Route path="/Estado de México" element={<EstadoDeMexico />} />
          <Route path="/Guanajuato" element={<Guanajuato />} />
          <Route path="/Guerrero" element={<Guerrero />} />
          <Route path="/Hidalgo" element={<Hidalgo />} />
          <Route path="/Jalisco" element={<Jalisco />} />
          <Route path="/Hidalgo" element={<Hidalgo />} />
          <Route path="/Michoacan" element={<Michoacan />} />
          <Route path="/Morelos" element={<Morelos />} />
          <Route path="/Nayarit" element={<Nayarit />} />
          <Route path="/Nuevo León" element={<NuevoLeon />} />
          <Route path="/Oaxaca" element={<Oaxaca />} />
          <Route path="/Puebla" element={<Puebla />} />
          <Route path="/Querétaro" element={<Queretaro />} />
          <Route path="/San Luis Potosí" element={<SanLuisPotosi />} />
          <Route path="/Sinaloa" element={<Sinaloa />} />
          <Route path="/Sonora" element={<Sonora />} />
          <Route path="/Tabasco" element={<Tabasco />} />
          <Route path="/Tamaulipas" element={<Tamaulipas />} />
          <Route path="/Tlaxcala" element={<Tlaxcala />} />
          <Route path="/Veracruz" element={<Veracruz />} />
          <Route path="/Ciudad de México" element={<CiudadDeMexico />} />
          <Route path="/Quintana Roo" element={<QuintanaRoo />} />
          <Route path="/Yucatán" element={<Yucatan />} />
          <Route path="/Zacatecas" element={<Zacatecas />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
